module.exports = __webpack_public_path__ + "static/media/automotores.3a8b0cc5.svg";